<template>
    <div class="card">
      <div class="card-header">
        <div class="row justify-content-between align-items-center">
          <div class="col">
            <button @click="() => open = !open" class="btn" type="button" data-toggle="collapse" data-target="#packageTypeCollapse" aria-expanded="false" aria-controls="packageTypeCollapse">
              <i v-if="open" class="fas fa-angle-up"></i>
              <i v-else class="fas fa-angle-down"></i>
              <h4 data-target="#packageTypeCollapse" aria-expanded="false" aria-controls="packageTypeCollapse" class="btn alert-heading font-18 text-dark">Ընթացիկ փաթեթ</h4>
            </button>
          </div>
          <div v-if="!me.probation && me.package === 'Անվճար' && userType === 'USER'"  class="col justify-content-end pr-4 row align-content-center">
            <button 
              @click="activateFreePeriod" 
              class="color-white btn btn-primary btn-round rounded-pill"
              style="box-shadow: none;"
            >
              Ակտիվացնել 10 օր ԱՆՎՃԱՐ փորձաշրջան
            </button>
          </div>
        </div>
      </div>
      <div id="packageTypeCollapse" class="collapse multi-collapse">
        <div class="card-body">
            <div class="form-group row d-flex align-items-center">
                <label for="example-text-input" class="col-sm-4 col-form-label text-right">Ընթացիկ փաթեթ</label>
                <div class="col-sm-6">
                    <span v-if="$t(`packages.${packageData.name}`) === 'packages.undefined'">չկա</span>
                    <span v-else class="pl-0 form-control border-0" id="example-text-input">{{packageData.name}} փաթեթ</span>
                </div>
            </div>
            <div class="form-group row">
                <label for="example-text-input" class="col-sm-4 col-form-label text-right">Գործողության
                    ժամկետ </label>
                <div class="col-sm-6">
                    <span class="pl-0 form-control border-0" id="example-text-input">{{ packageData.start_date }} - {{ packageData.end_date }}</span>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>


<script>
export default {
  name: 'packageType',
  data () {
    return {
      packageData: {},
      open: false,
      vat_payer_type: '',
    }
  },
  computed: {
    isCoordinator(){
       return +this.me.divisions === 2
    },
    me() {
      return this.$store.getters['user/me']
    },
    userType(){
      return this.$store.getters.userType
    } 
  },
  created(){ },
  mounted(){
    this.$client.get('user/package').then(({data: {data}}) => {
      if(data){
        this.packageData = data;
      }
    })
  },
  watch: {
    me(newValue, oldValue) {
      console.log(newValue)
      console.log(!newValue.probation)
      console.log(newValue.package === 'Անվճար')
      console.log(this.userType === 'USER')
      if(!newValue.probation && newValue.package === 'Անվճար' && this.userType === 'USER'){
      console.log('HERE')
        this.open = true;
      }
    },
  },
  methods: {
    consoleLog(e){
      console.log(e)
    },
    activateFreePeriod(){
        this.$confirm(
            "Ակտիվացնել Գոլդ փաթեթ 10 օրով", 
            "Ակտիվացնել", 
            "", 
            {
                title: 'Do you want to save the changes?',
                confirmButtonText: 'Ակտիվացնել', 
                cancelButtonText: 'Չեղարկել'
            }
        ).then((result) => {
            if(result){
                this.$client.post('gold/package/probation/activate').then((value) => {
                    this.$client.get('user/package').then(({data: {data}}) => {
                        this.packageData = data;
                    })
                    this.$store.dispatch('user/me')
                    this.$fire({
                        text: "Դուք հաջողությամբ ակտիվացրեցիք Գոլդ փաթեթը 10 օրով",
                        confirmButtonText: 'Լավ'
                    })
                })
            }
        }) 
    },
    save() {
      $client.put(`user`, {vat_payer_type: this.vat_payer_type}).then(({data}) => {
            if(data.data){
                this.$notify({
                    group: 'foo',
                    type: 'success',
                    text: 'Հաջողությամբ պահպանված է'
                })
            }
        }).catch(e => {
            this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Էլ. հացեն զբաղված է',
            text: 'Կրկին փորձեք!'
            })
        })
    },
  },
}
</script>
